import { type FC } from "react";
import { InformationPage } from "../../common/components/informationPage/InformationPage";
import { IMG_QUOTE_CONFIRMATION } from "../../utils/url/staticResources";
import { useTranslation } from "react-i18next";

interface Props {
  url: string;
  email: string;
  inquiryNumber: string;
}

const ContactUsConfirmationPage: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <InformationPage
      title={<div className="scha__contact-us-confirmation__headline">{t("contact.us.confirmation.title")}</div>}
      subtitle={
        <div className="scha__contact-us-confirmation__details">
          <div className="scha__contact-us-confirmation__details__inq">
            {t("contact.us.confirmation.messageNoLabel")}
            <strong>{props.inquiryNumber}</strong>
          </div>
          <div className="scha__contact-us-confirmation__details__email">
            {t("contact.us.confirmation.copySentToLabel")}
            <strong>{props.email}</strong>
          </div>
        </div>
      }
      btnSetup={{
        href: props.url,
        label: t("contactUsConfirmation.continueShopping"),
      }}
      imageSrc={IMG_QUOTE_CONFIRMATION}
    />
  );
};

export function createContactUsConfirmationPage(data: Props) {
  return <ContactUsConfirmationPage {...data} />;
}
